module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wISEAkFYVrjTgAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAbElEQVQY042QQQ2AMBAEpzjAAkjAAlqwABaQUC14ohKGB5CQ0gYm6ed2LtlrUCnQAikfNhVxA+IrUfPXqbsn8ZmVZNShtBDUmTItcGcrsAQrF2YkoK/VQJ2uGvtViy/RW6zJ40Oc/vxGzEWVA3o54tLmGqdZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/day/r.png
// module id = eff7b3a94a97378167a8
// module chunks = 13